import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import Row, { IRowProps } from './Row';

import { IColumn, SelectableType } from './types';
import RouteEnum from '../../../enums/RouteEnum';
import Fulltext from './Fulltext';

type identificator = any;

interface IListProps {
    title?: string
    className?: string
    columns: Array<IColumn>
    rows: Array<IRowProps['row']>
    selectable?: SelectableType
    selected?: Array<identificator>
    selectedStr?: string
    onChangeSelect?: (ids: identificator[]) => void
    onNew?: () => void
    onNewForSelect?: (cis?: number) => void
    onEditN?: (co?: string) => void
    onLink?: boolean
    onEdit?: IRowProps['onEdit']
    onDelete?: IRowProps['onDelete']
}

function List({ title, className, columns, rows, selectable, selected, selectedStr, onChangeSelect, onNew, onNewForSelect,
    onEditN, onLink, onEdit, onDelete }: IListProps) {
    const [filter, setFilter] = useState<string>('');

    return (
        <div className={'list ' + (className || '')}>
            <div
                style={{ alignItems: 'center' }}
                className='display-flex'>
                <div className='list-title w-100'>{title}</div>
                {
                    !!rows?.length &&
                    <Fulltext
                        value={filter}
                        onChange={e => setFilter(e.target.value)} />
                }
                {
                    onNew &&
                    <button
                        className='cursor-pointer text-success'
                        onClick={onNew}>
                        <FontAwesomeIcon
                            icon={icon({ name: 'plus' })}
                            size='sm' />
                    </button>
                }
                {
                    onNewForSelect &&
                    <button
                        className='cursor-pointer text-success'
                        onClick={() => onNewForSelect(selected?.[0] ? selected[0] : 0)}>
                        <FontAwesomeIcon
                            icon={icon({ name: 'plus' })}
                            size='sm' />
                    </button>
                }
                {
                    onEditN &&
                    <button
                        className='cursor-pointer text-success h-28 border-success'
                        onClick={() => onEditN(selected?.[0].toString() ? selected[0].toString() : '')}>
                        Upravit
                    </button>
                }
                {
                    onLink &&
                    <Link to={{ pathname: RouteEnum.KONVERZACE_DETAIL() }}
                        state={{ data: rows, sessionId: selectedStr }}
                        className='button-link'>
                        Detail
                    </Link>
                }

            </div>
            <table>
                <thead>
                    <tr>
                        {
                            columns.map(({ key, label }) => (
                                <th key={key}>
                                    {label}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        rows?.length ?
                            rows
                                .filter(row => {
                                    return columns.some(column =>
                                        row[column.key]
                                            .toString()
                                            .toLowerCase()
                                            .indexOf(filter.toLowerCase()) !== -1
                                    );
                                })
                                .map(row => {
                                    const active = selected?.includes(row.id);
                                    return (
                                        <Row
                                            key={row.id}
                                            columns={columns}
                                            row={row}
                                            selectable={selectable}
                                            selected={active}
                                            onClick={() => {
                                                if (!onChangeSelect) return;

                                                if (selectable === 'single') {
                                                    if (active) onChangeSelect([]);
                                                    else onChangeSelect([row.id]);
                                                }
                                                else if (selectable === 'multi') {
                                                    if (active) onChangeSelect((selected || []).filter(item => item !== row.id));
                                                    else onChangeSelect([...(selected || []), row.id]);
                                                }
                                            }}
                                            onEdit={onEdit}
                                            onDelete={onDelete}
                                        />
                                    );
                                }) :
                            <tr><td colSpan={100}>žádné záznamy</td></tr>
                    }
                </tbody>
            </table>
        </div >
    );
}

export default List;
